<template>
	<div class="detail_container">
		<div class="trainging_info">
			<div class="name">
				{{Description.TrainFullName}}
			</div>

			<div class="date">
				<div class="events-name">{{Description.EventsName}} /</div>
				<div class="time" v-if="TrainTime.BeginTime && TrainTime.EndTime">{{trainBeginTime}} - {{trainEndTime}}</div>
			</div>
			<div class="location">
                <YD-image src="icon/定位"></YD-image>
				<div class="location-name">
					{{location}}
				</div>
			</div>
		</div>
		<div class="status" v-if="statusInfo">
			<div class="img" :style="statusInfo.bubbleStyle">
				<YD-image :src="'match_detail/' + statusInfo.bubbleUrl"></YD-image>
				<div class="time">{{statusInfo.bubbleText}}</div>
			</div>
			<div class="progress_bar">
				<div class="progress_bar-bg" :class="'progress_' + statusInfo.progress"></div>
				<div class="node">
					<YD-image v-for="(item,index) in statusInfo.progressDot" :key="index"
						:src="'match_detail/' + item"></YD-image>
				</div>
			</div>
			<div class="text">
				<div v-for="(item, index) in statusInfo.progressText" :key="index">
					<div class="text-item"
						:class="[(index + 1) == statusInfo.progress ? statusInfo.progressTextClass : '', (index + 1) ==  statusInfo.progress ? 'old_status' : '']">
						{{item}}
					</div>
				</div>
			</div>
		</div>
		<div class="trainging_curriculum">
			<div class="type_title">
				<div class="type_name">培训内容</div>
			</div>
			<div class="curriculum_list">
				<div class="curriculum_item" v-for="item,index in Classes" :key="index">
					<div class="item-content">{{item}}</div>
				</div>
			</div>
		</div>
        <div class="unit" v-if="Units">
            <p class="type_title">
                <span class="type_name">组织机构</span>
                <span></span>
            </p>
            <ul>
                <li v-for="(item,index) in Units" :key="index">
                    <div class="unit_type" :style="item.Kind == '主办单位' ? 'color: #F06E43;background: #FFE9E2;' : ''">{{item.Kind}}</div>
                    <div class="unit_list">
                        <div v-for="(unitItem,unitIndex) in item.Units" :key="unitIndex">{{unitItem}}</div>
                    </div>
                </li>
            </ul>
        </div>
		<div class="detail">
			<div class="type_title">
				<div class="type_name">培训详情</div>
			</div>
            <div class="detail_content rich_text"
                ref="detailContent"
                v-html="Comment"
            ></div>
            <div class="image_list" v-if="trainData.PictureFiles">
				<img :src="item.FileUrl" v-for="(item, index) in trainData.PictureFiles" :key="index" @click="previewImage(item.FileUrl, imageUrls)" />
			</div>
			<div class="file_list" v-if="trainData.DocFiles">
				<div class="file_item" v-for="(item, index) in handleDocFiles" :key="index" @click="openFile(item.url, item.name)">
					<div class="file_icon" :class="item.className"></div>
					<div class="file_info">
						<div class="file_name">{{item.name}}</div>
						<div class="file_size">{{item.size}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import tools from '@/common/tools.js';
export default {
    name: "detail",
    props: {
        trainData: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
        }
    },
    watch:{
        Comment:{
            immediate: true,
            handler(newValue){
                if(newValue){
                    this.setCommentImage();
                }
            }
        }
    },
    computed: {
        trainBeginTime() {
            return tools.dateFormat(this.TrainTime.BeginTime, "yyyy年MM月dd日");
        },
        trainEndTime() {
            return tools.dateFormat(this.TrainTime.EndTime, "yyyy年MM月dd日");
        },
        location(){
            let {
                TrainPlace
            } = this.trainData;
            let location = ((TrainPlace.Region || {}).RegionName || '') + (TrainPlace.Address || '');
            return location || '未知';
        },
        Description() {
            return this.trainData.Description || {}
        },
        TrainTime() {
            return this.trainData.TrainTime || {}
        },
        EnrollTime() {
            return this.trainData.EnrollTime || {}
        },
        Classes(){
            return this.trainData.Classes || [];
        },
        Units() {
            if(!this.trainData.AllUnits) return;
            let units = this.trainData.AllUnits;
            return units;
        },
        Comment() {
            return this.trainData.Descs;
        },
        imageUrls(){
			if(!this.trainData.PictureFiles) return [];
			return this.trainData.PictureFiles.map(item=>item.FileUrl);
		},
		handleDocFiles(){
			if(!this.trainData.DocFiles) return [];
			return this.trainData.DocFiles.map(item=>{
				let name = item.FileName,
					url = item.FileUrl;
				let type = name.substr(name.lastIndexOf('.')).substr(1).toLowerCase();
				if(!type){
					type = url.substr(url.lastIndexOf('.')).substr(1).toLowerCase();
				}
				let className = type;
				if(['docx', 'doc'].includes(type)){
					className = 'word';
				}else if(['xlsx', 'xls'].includes(type)){
					className = 'excel';
				}else if(['pptx', 'ppt'].includes(type)){
					className = 'ppt';
				}else if(['pdf'].includes(type)){
					className = 'pdf';
				}
				return {
					url,
					name,
					type,
					size: tools.formatFileSize(item.FileSize),
					className
				}
			})
		},
        publicDay() {
            if (this.trainData.IsPublic) {
                let BeginTime = new Date(this.trainData.PublicBeginTime).getTime(),
                    EndTime = new Date(this.trainData.PublicEndTime).getTime();
                return Math.ceil((EndTime - BeginTime) / 1000 / 60 / 60 / 24);
            } else {
                return '';
            }
        },
        statusInfo() {
            var bubbleStyle,
                bubbleUrl,
                progress,
                progressText = ['报名中', '待开班', '培训中', '已结束'],
                bubbleText,
                progressDot = [],
                progressTextClass = "active";
            var data = this.trainData;
            if (data.TrainId) {
                if ([1,2].includes(data.NowStatus)) {
                    bubbleStyle = "width: 4.60rem; left: 0.06rem;";
                    bubbleUrl = "气泡_1";
                    if (data.NowStatus == 2) {
                        bubbleText =
                            `${tools.dateFormat(data.EnrollTime.BeginTime, 'yyyy年M月d日')} - ${tools.dateFormat(data.EnrollTime.EndTime, 'yyyy年M月d日')}`;
                    } else {
                        bubbleText = `报名开始时间：${tools.dateFormat(data.EnrollTime.BeginTime, 'yyyy年M月d日')}`;
                        progressText[0] = '未开始';
                    }
                    progress = 1;
                } else if (data.NowStatus == 3) {
                    bubbleStyle = "width: 4.26rem; left: 0.3rem;";
                    bubbleUrl = "气泡_2";
                    bubbleText =
                        `${tools.dateFormat(data.TrainTime.BeginTime, 'yyyy年M月d日')} - ${tools.dateFormat(data.TrainTime.EndTime, 'yyyy年M月d日')}`;
                    progress = 2;
                } else if (data.NowStatus == 4) {
                    bubbleStyle = "width: 4.26rem; right: 0.3rem;";
                    bubbleUrl = "气泡_2";
                    bubbleText =
                        `${tools.dateFormat(data.TrainTime.BeginTime, 'yyyy年M月d日')} - ${tools.dateFormat(data.TrainTime.EndTime, 'yyyy年M月d日')}`;
                    progress = 3;
                } else if (data.NowStatus == 5) {
                    bubbleStyle = "width: 4.6rem; right: -0.02rem;";
                    bubbleUrl = "气泡_3";
                    bubbleText = '培训已结束~请查看考核公示';
                    progress = 4;
                }
                for (var i = 1; i <= 4; i++) {
                    if (i < progress) {
                        progressDot.push('点_' + i);
                    } else if (i == progress) {
                        progressDot.push('点_active');
                    } else {
                        progressDot.push('点_disabled');
                    }
                }
            }
            return {
                bubbleStyle,
                bubbleUrl,
                progress,
                progressText,
                bubbleText,
                progressDot,
                progressTextClass
            }
        },

    },
    methods: {
        setCommentImage(){
            this.$nextTick(function(){
                if(!this.$refs.detailContent) return;
                let images = [],
                    imageDom = this.$refs.detailContent.querySelectorAll('img');
                if(imageDom.length > 0){
                    imageDom.forEach((item) => {
                        let url = item.getAttribute('src');
                        images.push(url);
                        item.onclick = ()=>{
                            this.previewImage(url, images);
                        }
                    });
                }
            });
        },
        previewImage(url, urls){
			if(!url) return;
			if(!urls){
				urls = [url];
			}
            let index = urls.indexOf(url);
            this.$emit('lookImage', {
                list: urls,
                index: index,
                show: true
            });
        },
        //查看文件
        openFile(url, name){
            this.$navigation.go(`/Rules/OnlinePreview?file_url=${encodeURIComponent(url)}&name=${name}&download=1`);
        }
    }
}
</script>
<style lang="scss">
	.detail_container {
		height: auto;
		width: 100%;
		padding: 40px;
		box-sizing: border-box;

		.trainging_info {
			width: 100%;
			height: auto;
			position: relative;
			box-sizing: border-box;

			.name {
				font-family: PingFangSC-Medium;
				font-size: 40px;
				color: #1B1C1E;
				font-weight: 500;
				line-height: 56px;

				img {
					margin-left: 8px;
					margin-bottom: -8px;
					width: 122px;
					height: 40px;
				}

			}

			.date {
				height: 48px;
				display: flex;
				margin-top: 16px;
				white-space: nowrap;
				font-family: PingFangSC-Regular;
				font-size: 28px;
				color: #1B1C1E;
				line-height: 48px;
				font-weight: 400;
				.events-name{
					margin-right: 8px;
				}
				.time{
					margin-left: 8px;
				}
			}

			.location {
				width: 100%;
				min-height: 48px;
				display: flex;
				margin-top: 8px;
				font-family: PingFangSC-Regular;
				font-size: 28px;
				color: #7E7E7F;
				line-height: 48px;
				font-weight: 400;

				img {
					width: 32px;
					height: 32px;
					margin-top: 4px;
				}

				.location-name {
					margin-left: 10px;
					width: calc(100vw - 100px);
				}
			}
		}

		// 比赛状态
		.status {
			width: 100%;
			height: 194px;
			margin-top: 32px;
			background: #FFFFFF;
			box-shadow: 0 20px 38px 0 #EBF2F5;
			border-radius: 20px;
			padding-top: 116px;
			box-sizing: border-box;
			position: relative;

			.img {
				position: absolute;
				top: 12px;
				width: 400px;
				height: 100px;

				img {
					width: 100%;
					height: 100%;
				}

				.time {
					width: 100%;
					@include line-height(34px);
					font-size: 20px;
					font-family: PingFangSC-Medium;
					color: #FFFFFF;
					text-align: center;
					text-shadow: 0 2px 4px rgba(48, 66, 137, 0.11);
					font-weight: 500;
					white-space: nowrap;
					position: absolute;
					top: 24px;
					left: 0px;
				}
			}

			.progress_bar {
				width: 566px;
				height: 4px;
				background: #E5E8E1;
				margin: 0 auto;
				position: relative;

				.progress_bar-bg {
					width: 0%;
					height: 100%;

					&.progress_2 {
						width: 33.3333%;
						background-image: linear-gradient(270deg, #7AD21A 2%, #29D268 50%, #00C2DC 98%);
					}

					&.progress_3 {
						width: 66.6666%;
						background-image: linear-gradient(-89deg, #7AD21A 2%, #29D268 50%, #00C2DC 99%);

					}

					&.progress_4 {
						width: 100%;
						background-image: linear-gradient(-89deg, #7AD21A 2%, #29D268 50%, #00C2DC 99%);

					}
				}

				.node {
					width: calc(566px + 28px);
					height: 56px;
					position: absolute;
					left: -14px;
					top: -25px;
					display: flex;
					align-items: center;
					justify-content: space-between;

					img {
						height: 28px;
						width: 28px;
					}
				}
			}

			.text {
				width: 100%;
				height: 36px;
				margin-top: 14px;
				display: flex;
				align-items: center;
				justify-content: space-between;

				.text-item {
					width: 134px;
					font-family: PingFangSC-Regular;
					font-size: 26px;
					color: #7E7E7F;
					font-weight: 400;
					text-align: center;

					&.active {
						font-family: PingFangSC-Medium;
						font-size: 26px;
						color: #7AD21A;
						font-weight: 500;
					}

					&.active_2 {
						font-family: PingFangSC-Regular;
						font-size: 26px;
						color: #3A3F49;
						font-weight: 400;
					}

					&.old_status {
						font-family: PingFangSC-Regular;
						font-size: 26px;
						color: #3A3F49;
						font-weight: 400;
					}
				}
			}
		}

		.type_title {
			width: 100%;
			height: 44px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			font-weight: 500;

			.type_name {
				font-family: PingFangSC-Medium;
				font-size: 32px;
				color: #B9B9B9;
				letter-spacing: 0;
				font-weight: 500;
			}
		}
		.trainging_curriculum{
			width: 100%;
			height: auto;
			margin-top: 48px;
			.curriculum_list{
				margin-top: 32px;
				.curriculum_item{
					margin-bottom: 24px;
					padding-left: 48px;
					box-sizing: border-box;
					&:last-of-type{
						margin-bottom: 0;
					}
					&:nth-of-type(2n){
						.item-content{
							--color: #F79611;
							background-color: #FEF1CD;
						}
					}
					&:nth-of-type(3n){
						.item-content{
							--color: #5390F6;
							background-color: #EDF6FF;
						}
					}
					.item-content{
						--color: #F06E43;
						width: 100%;
						min-height: 88px;
						padding: 24px 32px;
						border-radius: 20px;
						box-sizing: border-box;
						background-color: #FFE9E2;
						font-family: PingFangSC-Medium;
						font-size: 28px;
						color: var(--color);
						font-weight: 500;
						line-height: 40px;
						position: relative;
						&::before{
							content: '';
							width: 16px;
							height: 16px;
							border-radius: 50%;
							position: absolute;
							top: calc(50% - 8px);
							left: -48px;
							background-color: var(--color);
						}
					}
				}
			}
		}
		.unit{
            width: 100%;
            height: auto;
            box-sizing: border-box;
            margin-top: 56px;
            ul{
                margin-top: 20px;
                li{
                    width: 100%;
                    height: auto;
                    padding: 12px 0 4px;
                    display: flex;
                    .unit_type{
                        width: 126px;
                        @include line-height(40px);
                        background: #FEF1CD;
                        font-size: 24px;
                        color: #F79611;
                        font-weight: 400;
                        text-align: center;
                        margin-right: 16px;
                        margin-top: 3px;
                        border-radius: 20px;
                        border-top-left-radius: 0;
                        border-bottom-left-radius: 16px;
                        flex: none;
                    }
                    .unit_list{
                        width: calc(100% - 142px);
                        height: auto;
                        div{
                            width: 100%;
                            height: auto;
                            margin-bottom: 8px;

                            line-height: 40px;
                            font-size: 28px;
                            color: #585D65;
                            font-weight: 400;
                        }
                    }
                }
            }
        }
        .detail{
            margin-top: 56px;
            .detail_content{
                margin-top: 24px;
                & + .image_list,
                & + .file_list{
                    margin-top: 16px;
                }
            }
        }
        .image_list{
            width: 100%;
            height: auto;
            img{
                display: block;
                width: auto;
                max-width: 100%;
                height: auto;
                border-radius: 12px;
                margin: 0 auto;
                margin-bottom: 16px;
            }
        }
        .file_list{
            width: 100%;
            height: auto;
            .file_item{
                width: 100%;
                min-height: 108px;
                padding: 16px 24px;
                box-sizing: border-box;
                background: #FAFBFA;
                border-radius: 12px;
                margin-bottom: 16px;
                display: flex;
                align-items: center;
                &:last-of-type{
                    margin-bottom: 0;
                }
                .file_icon{
                    width: 76px;
                    height: 76px;
                    background: no-repeat center / 100%;
                    &.word{
                        background-image: url('~@/assets/images/icon/file_word@2x.png');
                    }
                    &.pdf{
                        background-image: url('~@/assets/images/icon/file_pdf@2x.png');
                    }
                    &.excel{
                        background-image: url('~@/assets/images/icon/file_excel@2x.png');
                    }
                    &.ppt{
                        background-image: url('~@/assets/images/icon/file_ppt@2x.png');
                    }
                }
                .file_info{
                    width: calc(100% - 76px);
                    padding-left: 12px;
                    box-sizing: border-box;
                    .file_name{
                        width: 100%;
                        font-weight: 400;
                        font-size: 28px;
                        color: #3A3F49;
                        line-height: 44px;
                    }
                    .file_size{
                        font-weight: 400;
                        font-size: 24px;
                        color: #8B8C8D;
                        line-height: 30px;
                    }
                }
            }
        }
	}
</style>
<style lang="scss">
@import '@assets/scss/richText.scss';
</style>